export const invertedMessages = {
  // Reassign Popover messages
  User: 'User.v2.label.ATTESTATIONS',
  Account: 'Account.v2.label.ATTESTATIONS',
  Role: 'Role.v2.label.ATTESTATIONS',
  Entitlement: 'Account.v2.label.ATTESTATIONS',
  'Child Entitlement': 'Ent2_DISPLAYNAME.CERTIFICATIONS',
  'By reassigning this {lineItem}, their associated items will be included. Any approvals or rejections will be cleared upon reassignment.':
    'CERTS_REASSIGN_TITLE',
  Cancel: 'CERTS_CANCEL',
  'Got it': 'CERTS_REJECT_SECONDARY_BTN',
};
